<script>
  import { fly } from 'svelte/transition';
  import { asnavigate } from '../Utils/asnavigation.js';
  import { useNavigate } from 'svelte-navigator';
  const navigate = useNavigate();
  import {
    finalType,
    idDb,
    idTrappe,
    nomTrappe,
    choix,
    dimLongueur,
    dimLargeur,
    sensOuverture,
    fermeture,
    type,
    couleur,
    epaisseur,
    dureeResistance,
    dimLongueurIdFiche,
    dimLargeurIdFiche,
    sensOuvertureIdFiche,
    fermetureIdFiche,
    typeIdFiche,
    couleurIdFiche,
    epaisseurIdFiche,
    dureeResistanceIdFiche,
    coupeFeuIdPath,
    trappePath,
    quantite,
    commentaire,
    coordonnees,
  } from '../stores.js';
  import { saveCommande, asAlert } from '../Utils/saveInDb';
  import LineSideBar from '../ComponentsInProcess/LineSideBar.svelte';
  import Modal, { getModal } from '../Components/Modal.svelte';
  // import countryListAlpha2 from '../Utils/Countries.js';
  import { resetTrappeOption } from '../Utils/saveInDb';

  function sendInfos() {
    $coordonnees['asNewsletter'] =
      document.querySelector('#checkbox-1').checked;
    // asAlert('sendInfos');

    saveCommande(true, 'particulier', $coordonnees)
    .then(idDbResolve => {
        console.log("ID obtenu:", idDbResolve);
        $idDb = idDbResolve;
        //   console.log(`idDb: ${idDb}`);
        // clearStoreData();
        resetTrappeOption();
        // getModal().open(setSelection);
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        $finalType = 'particulier';
        asnavigate(navigate, '/merci');
    })
    .catch(error => {
        console.error("Erreur:", error);
    });

    // let $idDb = saveCommande(true, 'particulier', $coordonnees);
    // if ($idDb !==false) {
    //   console.log(`idDb: ${idDb}`);
    //   // clearStoreData();
    //   // resetTrappeOption();
    //   // getModal().open(setSelection);
    //   document.body.scrollTop = 0; // For Safari
    //   document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    //   $finalType = 'particulier';
    //   asnavigate(navigate, '/merci');
    // } else {
    //   alert("Une erreur c'est produite");
    // }
  }


  let selection;
  // Callback function provided to the `open` function, it receives the value given to the `close` function call, or `undefined` if the Modal was closed with escape or clicking the X, etc.
  function setSelection() {
    asnavigate(navigate, '/');
  }

  export function clearStoreData() {
    // const map1 = $coordonnees.map((x) => '');
    // console.log(map1);
    Object.entries($coordonnees).forEach(([key, value]) => {
      $coordonnees.key = '';
      // console.log(`${key}: ${value}`);
    });
  }

  const countryList = {
    AF: 'Afghanistan',
    AX: 'Åland Islands',
    AL: 'Albania',
    DZ: 'Algeria',
    AS: 'American Samoa',
    AD: 'Andorra',
    AO: 'Angola',
    AI: 'Anguilla',
    AQ: 'Antarctica',
    AG: 'Antigua and Barbuda',
    AR: 'Argentina',
    AM: 'Armenia',
    AW: 'Aruba',
    AU: 'Australia',
    AT: 'Austria',
    AZ: 'Azerbaijan',
    BS: 'Bahamas (the)',
    BH: 'Bahrain',
    BD: 'Bangladesh',
    BB: 'Barbados',
    BY: 'Belarus',
    BE: 'Belgique',
    BZ: 'Belize',
    BJ: 'Benin',
    BM: 'Bermuda',
    BT: 'Bhutan',
    BO: 'Bolivia (Plurinational State of)',
    BQ: 'Bonaire, Sint Eustatius and Saba',
    BA: 'Bosnia and Herzegovina',
    BW: 'Botswana',
    BV: 'Bouvet Island',
    BR: 'Brazil',
    IO: 'British Indian Ocean Territory (the)',
    BN: 'Brunei Darussalam',
    BG: 'Bulgaria',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    CV: 'Cabo Verde',
    KH: 'Cambodia',
    CM: 'Cameroon',
    CA: 'Canada',
    KY: 'Cayman Islands (the)',
    CF: 'Central African Republic (the)',
    TD: 'Chad',
    CL: 'Chile',
    CN: 'China',
    CX: 'Christmas Island',
    CC: 'Cocos (Keeling) Islands (the)',
    CO: 'Colombia',
    KM: 'Comoros (the)',
    CD: 'Congo (the Democratic Republic of the)',
    CG: 'Congo (the)',
    CK: 'Cook Islands (the)',
    CR: 'Costa Rica',
    HR: 'Croatia',
    CU: 'Cuba',
    CW: 'Curaçao',
    CY: 'Cyprus',
    CZ: 'Czechia',
    CI: "Côte d'Ivoire",
    DK: 'Denmark',
    DJ: 'Djibouti',
    DM: 'Dominica',
    DO: 'Dominican Republic (the)',
    EC: 'Ecuador',
    EG: 'Egypt',
    SV: 'El Salvador',
    GQ: 'Equatorial Guinea',
    ER: 'Eritrea',
    EE: 'Estonia',
    SZ: 'Eswatini',
    ET: 'Ethiopia',
    FK: 'Falkland Islands (the) [Malvinas]',
    FO: 'Faroe Islands (the)',
    FJ: 'Fiji',
    FI: 'Finland',
    FR: 'France',
    GF: 'French Guiana',
    PF: 'French Polynesia',
    TF: 'French Southern Territories (the)',
    GA: 'Gabon',
    GM: 'Gambia (the)',
    GE: 'Georgia',
    DE: 'Germany',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Greece',
    GL: 'Greenland',
    GD: 'Grenada',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernsey',
    GN: 'Guinea',
    GW: 'Guinea-Bissau',
    GY: 'Guyana',
    HT: 'Haiti',
    HM: 'Heard Island and McDonald Islands',
    VA: 'Holy See (the)',
    HN: 'Honduras',
    HK: 'Hong Kong',
    HU: 'Hungary',
    IS: 'Iceland',
    IN: 'India',
    ID: 'Indonesia',
    IR: 'Iran (Islamic Republic of)',
    IQ: 'Iraq',
    IE: 'Ireland',
    IM: 'Isle of Man',
    IL: 'Israel',
    IT: 'Italy',
    JM: 'Jamaica',
    JP: 'Japan',
    JE: 'Jersey',
    JO: 'Jordan',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KP: "Korea (the Democratic People's Republic of)",
    KR: 'Korea (the Republic of)',
    KW: 'Kuwait',
    KG: 'Kyrgyzstan',
    LA: "Lao People's Democratic Republic (the)",
    LV: 'Latvia',
    LB: 'Lebanon',
    LS: 'Lesotho',
    LR: 'Liberia',
    LY: 'Libya',
    LI: 'Liechtenstein',
    LT: 'Lithuania',
    LU: 'Luxembourg',
    MO: 'Macao',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaysia',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malta',
    MH: 'Marshall Islands (the)',
    MQ: 'Martinique',
    MR: 'Mauritania',
    MU: 'Mauritius',
    YT: 'Mayotte',
    MX: 'Mexico',
    FM: 'Micronesia (Federated States of)',
    MD: 'Moldova (the Republic of)',
    MC: 'Monaco',
    MN: 'Mongolia',
    ME: 'Montenegro',
    MS: 'Montserrat',
    MA: 'Morocco',
    MZ: 'Mozambique',
    MM: 'Myanmar',
    NA: 'Namibia',
    NR: 'Nauru',
    NP: 'Nepal',
    NL: 'Netherlands (the)',
    NC: 'New Caledonia',
    NZ: 'New Zealand',
    NI: 'Nicaragua',
    NE: 'Niger (the)',
    NG: 'Nigeria',
    NU: 'Niue',
    NF: 'Norfolk Island',
    MP: 'Northern Mariana Islands (the)',
    NO: 'Norway',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palau',
    PS: 'Palestine, State of',
    PA: 'Panama',
    PG: 'Papua New Guinea',
    PY: 'Paraguay',
    PE: 'Peru',
    PH: 'Philippines (the)',
    PN: 'Pitcairn',
    PL: 'Poland',
    PT: 'Portugal',
    PR: 'Puerto Rico',
    QA: 'Qatar',
    MK: 'Republic of North Macedonia',
    RO: 'Romania',
    RU: 'Russian Federation (the)',
    RW: 'Rwanda',
    RE: 'Réunion',
    BL: 'Saint Barthélemy',
    SH: 'Saint Helena, Ascension and Tristan da Cunha',
    KN: 'Saint Kitts and Nevis',
    LC: 'Saint Lucia',
    MF: 'Saint Martin (French part)',
    PM: 'Saint Pierre and Miquelon',
    VC: 'Saint Vincent and the Grenadines',
    WS: 'Samoa',
    SM: 'San Marino',
    ST: 'Sao Tome and Principe',
    SA: 'Saudi Arabia',
    SN: 'Senegal',
    RS: 'Serbia',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapore',
    SX: 'Sint Maarten (Dutch part)',
    SK: 'Slovakia',
    SI: 'Slovenia',
    SB: 'Solomon Islands',
    SO: 'Somalia',
    ZA: 'South Africa',
    GS: 'South Georgia and the South Sandwich Islands',
    SS: 'South Sudan',
    ES: 'Spain',
    LK: 'Sri Lanka',
    SD: 'Sudan (the)',
    SR: 'Suriname',
    SJ: 'Svalbard and Jan Mayen',
    SE: 'Sweden',
    CH: 'Suisse',
    SY: 'Syrian Arab Republic',
    TW: 'Taiwan (Province of China)',
    TJ: 'Tajikistan',
    TZ: 'Tanzania, United Republic of',
    TH: 'Thailand',
    TL: 'Timor-Leste',
    TG: 'Togo',
    TK: 'Tokelau',
    TO: 'Tonga',
    TT: 'Trinidad and Tobago',
    TN: 'Tunisia',
    TR: 'Turkey',
    TM: 'Turkmenistan',
    TC: 'Turks and Caicos Islands (the)',
    TV: 'Tuvalu',
    UG: 'Uganda',
    UA: 'Ukraine',
    AE: 'United Arab Emirates (the)',
    GB: 'United Kingdom of Great Britain and Northern Ireland (the)',
    UM: 'United States Minor Outlying Islands (the)',
    US: 'United States of America (the)',
    UY: 'Uruguay',
    UZ: 'Uzbekistan',
    VU: 'Vanuatu',
    VE: 'Venezuela (Bolivarian Republic of)',
    VN: 'Viet Nam',
    VG: 'Virgin Islands (British)',
    VI: 'Virgin Islands (U.S.)',
    WF: 'Wallis and Futuna',
    EH: 'Western Sahara',
    YE: 'Yemen',
    ZM: 'Zambia',
    ZW: 'Zimbabwe',
  };
</script>

<Modal>
  <div class="modal-wrapper">
    <div class="as-soustitre">Merci pour votre demande !</div>
    <p class="">
      Nous vous remercions pour l’intérêt que vous portez à nos produits.<br />
      Vous allez recevoir un mail avec votre configuration.
    </p>
    <p style="font-weight:bold;">
      Pour passer commande, merci de vous rendre chez l’un de nos<br /> distributeurs partenaires présents partout en France.
    </p>

    <a href="https://www.semin.fr/partenaires-distributeurs" target="_blank" class="as-btn-rounded">
      Nos distributeurs partenaires 
    </a>
  </div>
</Modal>

<!-- <Modal>
  <div class="modal-wrapper">
    <div class="as-soustitre">Vous allez recevoir un mail de confirmation</div>
    <p class="">
      Nous vous remercions pour l’intérêt que vous portez à nos produits.
    </p>
    <p class="">
      Nous allons prendre contact avec vous et vous faire une offre de prix.
    </p>
    <p class="team">Cordialement. LA TEAM SEMIN</p>
    <div class="as-btn-rounded" on:click="{() => getModal().close()}">
      Retour à l'accueil
    </div>
  </div>
</Modal> -->

<div class="as-container-neu">
  <div class="container  mx-auto items-start flex ">
    <div class="w-full md:w-full lg:w-6/12 xl:w-6/12 pr-20">
      <div in:fly="{{ delay: 50, x: 100, duration: 800 }}">
        <div class="as-soustitre">Configuration de votre trappe</div>
        {#if $nomTrappe}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="false"
              hasLink="false"
              idPage=""
              titre="{'Choix de la trappe <strong>' + $nomTrappe + '</strong>'}"
            />
          </div>
        {/if}
        {#if $type}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$typeIdFiche}"
              titre="{'Type d’installation : <strong>' + $type + '</strong> '}"
            />
          </div>
        {/if}
        {#if $dureeResistance}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$dureeResistanceIdFiche}"
              titre="{'Durée résistance au feu : <strong>' +
                $dureeResistance +
                '</strong> '}"
            />
          </div>
        {/if}
        {#if $epaisseur}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$epaisseurIdFiche}"
              titre="{'Epaisseur : <strong>' + $epaisseur + '</strong> '}"
            />
          </div>
        {/if}

        {#if $dimLongueur}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$dimLongueurIdFiche}"
              titre="{'Longueur de la trappe : <strong>' +
                $dimLongueur +
                ' mm</strong>'}"
            />
          </div>
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$dimLongueurIdFiche}"
              titre="{'Largeur de la trappe : <strong>' +
                $dimLargeur +
                ' mm</strong>'}"
            />
          </div>
        {/if}
        {#if $sensOuverture}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$sensOuvertureIdFiche}"
              titre="{'Côté d’ouverture : <strong>' +
                $sensOuverture +
                ' </strong>'}"
            />
          </div>
        {/if}

        {#if $fermeture}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$fermetureIdFiche}"
              titre="{'Fermeture : <strong>' + $fermeture + ' </strong>'}"
            />
          </div>
        {/if}
        {#if $couleur != ''}
          <div
            class="as-line-border"
            in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
          >
            <LineSideBar
              linecolor="#000"
              hasIcon="true"
              idPage="/LayoutPage/{$couleurIdFiche}"
              titre="{'Couleur : <strong>' + $couleur + ' </strong>'}"
            />
          </div>
        {/if}
        <div
          class="as-line-border"
          in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
        >
          <LineSideBar
            linecolor="#000"
            hasIcon="true"
            idPage="/recapitulatif/"
            titre="{'Quantité : <strong>' + $quantite + ' </strong>'}"
          />
        </div>
        <div
          class="as-line-border"
          in:fly="{{ delay: 0, x: 10, duration: 1500 }}"
        >
          <LineSideBar
            linecolor="#000"
            hasIcon="true"
            idPage="/recapitulatif/"
            titre="{'Commentaire : <span style="font-family: \'introlight\';font-size: 16px;color: #000;">' +
              $commentaire +
              ' </span>'}"
          />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <span
            class="as-edit"
            on:click="{() => asnavigate(navigate, '/recapitulatif')}"
          >
            Editer votre trappe
          </span>
        </div>
      </div>
    </div>
    <div class="w-full md:w-full lg:w-6/12 xl:w-6/12">
      <div class="as-soustitre">Vos coordonnées</div>
      <div class="grid grid-cols-1 ">
        <div in:fly="{{ delay: 100, x: 100, duration: 800 }}">
          <input
            name="as-post-nom"
            value="{$coordonnees.asNom}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre nom"
          />
        </div>
        <div in:fly="{{ delay: 200, x: 100, duration: 800 }}">
          <input
            name="as-post-prenom"
            value="{$coordonnees.asPrenom}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre prénom"
          />
        </div>
        <div in:fly="{{ delay: 300, x: 100, duration: 800 }}">
          <input
            name="as-post-email"
            value="{$coordonnees.asEmail}"
            type="email"
            class="as-input-neu"
            disabled
            placeholder="Votre adresse email"
          />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-tel"
            value="{$coordonnees.asTel}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre téléphone"
          />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-adresse"
            value="{$coordonnees.asAdresse}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre adresse"
          />
        </div>
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-cp"
            value="{$coordonnees.asCp}"
            type="number"
            class="as-input-neu"
            disabled
            placeholder="Votre code postal"
            maxlength="5"
          />
        </div>

        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-ville"
            value="{$coordonnees.asVille}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre Ville"
          />
        </div>

        <!-- value="{countryList[$coordonnees.asPays]}" -->
        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-revendeur"
            value="{countryList[$coordonnees.asPays]}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder="Votre Pays"
          />
        </div>

        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <input
            name="as-post-revendeur"
            value="{$coordonnees.asRevendeur}"
            type="text"
            class="as-input-neu"
            disabled
            placeholder=""
          />
        </div>

        <div in:fly="{{ delay: 400, x: 100, duration: 800 }}">
          <span
            class="as-edit"
            on:click="{() =>
              asnavigate(navigate, '/process/particulier/coordonnees')}"
          >
            Editer vos coordonnées
          </span>
        </div>
      </div>
    </div>
  </div>

  <hr />

  <div in:fly="{{ delay: 500, x: 100, duration: 800 }}">
    <div class="flex mb-8">
      <div class="flex-none">
        <div class="checkbox">
          <div class="checkbox__1 pr-8">
            <input id="checkbox-1" type="checkbox" />
            <label for="checkbox-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28px"
                height="28px"
                preserveAspectRatio="xMidYMid meet"
                viewBox="0 0 16 16"
                ><path
                  fill="currentColor"
                  d="M10.97 4.97a.75.75 0 0 1 1.07 1.05l-3.99 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093l3.473-4.425a.267.267 0 0 1 .02-.022z"
                ></path></svg
              >
            </label>
          </div>
        </div>
      </div>
      <div class="flex-1 w-64 pt-1">
        J'accepte de recevoir la newsletter de la part de « Semin » En
        renseignant votre adresse mail, vous consentez à recevoir la newsletter
        mensuelle de la part de Semin. Vous pouvez vous désinscrire à tout
        moment à l'aide des liens de désinscription dans l'e-mail.
      </div>
    </div>
  </div>

  <div class="grid grid-cols-3 gap-4 place-items-center">
    <div class="col-span-2 as-warning">
      <div in:fly="{{ delay: 600, x: 100, duration: 800 }}">
        En validant, vos informations vos être envoyées à l'équipe Semin. Pensez
        donc à bien vérifier vos données
      </div>
    </div>
    <div>
      <div in:fly="{{ delay: 800, x: 100, duration: 800 }}">
        <div class="as-btn-rounded" on:click="{() => sendInfos()}">Valider</div>
      </div>
    </div>
  </div>
</div>

<style>
  /* .alert {
    font-family: 'introlight';
    font-size: 15px;
    color: rgb(175, 0, 0);
    font-style: italic;
    margin-top: 40px;
  } */
  .modal-wrapper {
    text-align: center;
    padding: 40px 60px;
  }
  .modal-wrapper p {
    padding-bottom: 20px;
  }
  .modal-wrapper .as-btn-rounded {
    margin-top: 20px;
  }
  hr {
    border-bottom: 1px solid #e1e1e1;
    margin: 40px 0 36px;
  }
  .as-warning {
    font-family: 'introlight';
    font-size: 15px;
    color: #000;
    font-style: italic;
  }
  .as-soustitre {
    font-family: 'introblack';
    font-size: 25px;
    line-height: 30px;
    margin-bottom: 30px;
  }
  input.as-input-neu {
    height: 38px;
  }
  .as-container-neu .grid:not(.as-line) {
    gap: 22px 30px;
  }
  .as-edit {
    display: inline-block;
    cursor: pointer;
    font-family: 'introlight';
    font-size: 14px;
    color: #767676;
    border-bottom: 1px solid #cbcbcb;
    padding-top: 11px;
    padding-bottom: -5px;
    margin-left: 5px;
    transition: all 300ms;
  }
  .as-edit:hover {
    color: #000;
    border-color: #000;
  }
  .as-btn-rounded {
    margin-top: 0;
  }
  input:disabled {
    color: #000;
    border: 1px solid #dedede;
    box-shadow: none;
    opacity: 1 !important;
  }
  @media only screen and (max-width: 768px) {
    .as-container-neu {
      padding: 60px 40px;
    }
    .container.flex {
      display: block;
    }
    .container.flex > div {
      margin-bottom: 65px;
    }
    .grid-cols-3 {
      display: block;
      text-align: center;
      margin-top: 40px;
    }
    .as-btn-rounded {
      margin-top: 30px;
      margin-bottom: 20px;
    }
  }
</style>
